import { AfterViewInit, ChangeDetectorRef, Component, OnInit, ViewChild, ViewContainerRef } from '@angular/core';
import { addDays, subDays } from 'date-fns';
import { NovoDataTable, IDataTableSelectionOption, IDataTableColumn, IDataTablePaginationOptions, IDataTableSearchOptions, NovoModalService, IDataTablePreferences, IDataTableColumnFilterConfig, NovoAsideService, RemoteDataTableService, NOVO_VALUE_THEME, NOVO_VALUE_TYPE, NovoToastService } from 'novo-elements';
import { Subject } from 'rxjs';
import { HttpService } from './services/http.service';
import { AppBridgeService } from './services/appBridge.service';
import { UserSettings } from './interfaces/bullhorn';
import { Category, EntityTypes, JobOrder, ToManyRef } from '@bullhorn/bullhorn-types';
import { FieldMap, Staffing } from '@bullhorn/taurus';
import { MetaService } from './services/meta.service';
import { QueueModal } from './components/queue-modal.component';
import { JobOrderRemoteDataTableService } from './services/customObjectTable.service';
import { ActivatedRoute } from '@angular/router';
import { environment } from 'src/environments/environment';
@Component({
  selector: 'cubex-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements AfterViewInit, OnInit {
  loading = true;
  connected = true;
  isNovoEnabled = false;
  targetLoading = {};
  targetSubmitted = {};

  public paginationOptions: IDataTablePaginationOptions = {
    theme: 'standard',
    pageSize: 50,
    pageSizeOptions: [10, 50, 100, 250, 500],
  }

  // Table configuration
  public dataSetOptions: any[] = [
    { label: 'Dataset #1', value: 1 },
    { label: 'Dataset #2', value: 2 },
    { label: 'Dataset #3', value: 3 },
  ];
  public loadedDataSet: number = 1;
  public paginationTypeOptions: any[] = [
    { label: 'Standard', value: 'standard' },
    { label: 'Basic', value: 'basic' },
  ];
  public selectionOptions: IDataTableSelectionOption[] = [];
  public loadedPaginationType: string = 'standard';
  public globalSearchOptions: any[] = [
    { label: 'Show', value: true },
    { label: 'Hide', value: false },
  ];
  public loadedGlobalSearch: boolean = false;
  public customStatusColumnValue: string = '';
  public customStatusColumnOptions: object[] = [
    {
      label: 'Has A 5 in status',
      value: '5',
    },
    {
      label: 'All',
      value: '',
    },
  ];
  public sharedDisplayColumns: any = [];
  public retentionEnabled: boolean = false;

  // Shared configuration
  public sharedColumns: IDataTableColumn<any>[] = [];

  public widePaginationOptions: IDataTablePaginationOptions = {
    theme: 'basic-wide',
    pageSize: 10,
    pageSizeOptions: [10, 50, 100, 250, 500],
  };
  public sharedSearchOptions: IDataTableSearchOptions = {
    placeholder: 'Search for things...',
    tooltip: 'HELLO',
  };
  public sharedDefaultSort: { id: string; value: string } = {
    id: 'id',
    value: 'asc',
  };
  public refreshSubject: Subject<boolean> = new Subject();

  // Basic configuration
  public selectedRecordId: string = '';
  public remoteService: JobOrderRemoteDataTableService;

  constructor(private viewRef: ViewContainerRef, private ref: ChangeDetectorRef, private toastService: NovoToastService, private modalService: NovoModalService, private appBridgeService: AppBridgeService, private httpService: HttpService, private meta: MetaService, private aside: NovoAsideService, private route: ActivatedRoute) {
    document.documentElement.className = 'custom-menu-item';
    this.remoteService = new JobOrderRemoteDataTableService(this.httpService, this.route);
    this.toastService.parentViewContainer = viewRef;
  }

  ngAfterViewInit() {

  }

  ngOnInit(): void {
    if (this.connected) {
      this.appBridgeService.onRegistered.subscribe(this.onRegistered.bind(this));
      this.appBridgeService.register();
    }
  }

  get filterConfigText(): string {
    if(Object.keys(this.remoteService.additionalFilters)) {
      const htmlText = `
        This Job List is filtered to show only jobs that match the following criteria:
        <ul>
          ${Object.keys(this.remoteService.additionalFilters).map((key) => {
            let label = key;
            let values = this.remoteService.additionalFilters[key];
            switch (key) {
              case 'customText6':
                label = 'Minimum Years of Experience Values:';
                break;
              case 'yearsRequired':
                label = 'Maximum Years of Experience Values:';
                break;
              case 'categories.id':
                label = 'Categories';
                values = this.remoteService.jobCategories.map((category) => category.name).join(', ');
                break;
              case 'id':
                label = 'NOT Job ID';
                values = this.remoteService.additionalFilters[key].not;
                break;
              default:
                break;
            }


            return `<li><strong>${label}</strong>: ${values}</li>`
          }).join('')}
          <li><strong>In those jobs, we exclude candidates with IDs: </strong> ${this.remoteService.candidateIds}</li>
          <li><strong>In those jobs, we filter for candidate status</strong>: Active and Active - NoCo</li>
          <li><strong>In those jobs, we filter for submission status</strong>: Client Submitted, Bite, Interview, 2nd Interview, 3rd Interview</li>
        </ul>
      `;

      return htmlText;
    }

    return '';

    
  }

  public close() {
    this.appBridgeService.close();
  }

  public refresh() {
    this.appBridgeService.refresh();
  }

  public getPriority(): string {
    const x = Math.round(Math.random() * 50);
    return 'test ' + x.toString();
  }

  public getPriorityOptions() {
    const options = new Array();
    let i;
    for (i = 0; i < 49; i++) {
      options.push('test ' + i.toString());
    }
    return options;
  }


  public ownerFieldMeta: any = {
    type: NOVO_VALUE_TYPE.DEFAULT,
    name: EntityTypes.CorporateUser,
    associatedEntity: {
      entity: EntityTypes.CorporateUser,
    },
    showEntityIcon: false,
    entityIconClass: 'user',
    formatter: (value, args) => {
      return `${value?.name}`;
    },
  };

  public jobFieldMeta: any = {
    type: NOVO_VALUE_TYPE.INTERNAL_LINK,
    name: EntityTypes.JobOrder,
    associatedEntity: {
      entity: EntityTypes.JobOrder,
    },
    showEntityIcon: true,
    entityIconClass: 'job',
    formatter: (value, args) => {
      return `#${value?.id} | ${value?.title}`;
    },
    openLink: (value, meta) => {
      this.appBridgeService.execute(bridge => bridge.open({ entityId: value.id, entityType: EntityTypes.JobOrder, type: 'record' }));
    },
  };


  public companyFieldMeta: any = {
    type: NOVO_VALUE_TYPE.INTERNAL_LINK,
    name: EntityTypes.ClientCorporation,
    associatedEntity: {
      entity: EntityTypes.ClientCorporation,
    },
    showEntityIcon: true,
    entityIconClass: 'company',
    openLink: (value, meta) => {
      this.appBridgeService.execute(bridge => bridge.open({ entityId: value.id, entityType: EntityTypes.ClientCorporation, type: 'record' }));
    },
    formatter: (value, args) => {
      return `${value?.name}`;
    },
  };
  public candidateFieldMeta: any = {
    type: NOVO_VALUE_TYPE.INTERNAL_LINK,
    name: EntityTypes.Candidate,
    associatedEntity: {
      entity: EntityTypes.Candidate,
    },
    showEntityIcon: true,
    entityIconClass: 'candidate',
    openLink: (value, meta) => {
      this.appBridgeService.execute(bridge => bridge.open({ entityId: value.id, entityType: EntityTypes.Candidate, type: 'record' }));
    },
    formatter: (value, args) => {
      return `${value?.name}`;
    },
  };

  openQueueSlideout() {
    this.aside.open(QueueModal);
  }

  public log(event: { originalEvent: MouseEvent; row: any }): void {
    console.log('[DataTable] Event Triggered!', event); // tslint:disable-line
  }

  public preview(candidate, submission): void {
    this.appBridgeService.execute(bridge => {
      console.log(bridge);
      return bridge.open({
        entityType: EntityTypes.Candidate, 
        type: 'preview', 
        data: {
          id: candidate.id,
          title: candidate.name,
          cellData: {...submission, jobSubmission: submission},
          showSubmissionHistory: true
        }
      })
    });
  }

  public async addTarget(submission): Promise<void> {
    this.targetLoading[submission.id] = true;
    const entityId = this.route.snapshot.queryParamMap.get('EntityID') as any ;
    const userId = this.route.snapshot.queryParamMap.get('UserID') as any;

    const submissionPromise = this.httpService.getEntity(EntityTypes.JobSubmission, submission.id as any, 'candidate(name,id,firstName,lastName,owner(name,id,email))');
    const jobOrderPromise =  this.httpService.getEntity(EntityTypes.JobOrder, entityId as any, 'title,id,clientCorporation,owner(name,id,email)');
    const currentUserPromise = this.httpService.getEntity(EntityTypes.CorporateUser,userId as any , 'name,id,email');

    let [submissionRes, jobOrder, corporateUser] = await Promise.all([submissionPromise, jobOrderPromise,currentUserPromise]);

   await this.submitTarget(submissionRes.data, jobOrder.data, corporateUser.data);
    this.targetLoading[submission.id] = false;
    this.targetSubmitted[submission.id] = true;

   this.toastService.alert({theme: 'success', message: 'Target Sent!', position: 'fixedTop', icon: 'check', hideDelay: 3000});
  }

  
  public checkDisabled(): boolean {
    return true;
  }

  public configureColumns(): void {
    
  }

  public onPreferencesChanged(event: IDataTablePreferences): void {
    console.log('Preferences changed (persist manually):', event); // tslint:disable-line
  }

  public resized(event): void {
    console.log('Column Width changed (persist manually): ', event); // tslint:disable-line
  }

  private async onRegistered(isRegistered, ...args) {
    console.log(...args);
    if (isRegistered) {
      const userSettings: UserSettings = await this.httpService.getSettings('corporationId,privateLabelId,userId,novoEnabled');

      this.meta.setEntity(EntityTypes.JobOrder)

      let fields = await this.meta.getFields();
      const fieldsToDisplay = ['clientCorporation', 'title', 'owner', 'dateAdded'];
      fields = fields.filter((field) => fieldsToDisplay.includes(field.name));
      this.sharedColumns = fields.map((field) => { 
        return {
          id: field.name, 
          label: field.label,
          enabled: true,
          type: this.dataTypeToColumnType(field.dataType as string),
          filterable: this.dataTypeToColumnFilterType(field.dataType as string),
          resizable: true,
          sortable: true,
        };
      });

      this.sharedDisplayColumns = ['expand', ...fieldsToDisplay];

      this.loading = false;


    } else {
      this.connected = false;
      this.loading = false;
    }
  }

  private dataTypeToColumnType(dataType: string): IDataTableColumn<any>['type'] {
    dataType = dataType?.toLowerCase();
    switch (dataType) {
      case 'timestamp':
        return 'datetime';
      case 'integer':
        return 'number';
      case 'string':
      default:
        return 'text';
    }
  }

  private dataTypeToColumnFilterType(dataType: string): boolean | IDataTableColumnFilterConfig {
    dataType = dataType?.toLowerCase();
    switch (dataType) {
      case 'timestamp':
        return {
          type: 'date',
          allowCustomRange: true,
        };
      case 'string':
      default:
        return true;
    }
  }

  public async submitTarget(submission, jobOrder, fromUser) {
    const createNotePromis = this.httpService.createEntity(EntityTypes.Note, {
      comments: '',
      multipleNotes: false,
      personReference: {
        searchEntity: "Candidate",
          id: submission?.candidate.id,
          firstName: submission?.candidate.firstName,
          lastName: submission?.candidate.lastName,
      },
      action: "Target",
      nextAction: "None",
      minutesSpent: 0,
      jobOrders: [
          {
              id: jobOrder.id,
          }
      ]
    });

    const createSubmissionPromise = this.httpService.createEntity(EntityTypes.JobSubmission, {
      candidate: {
        id: submission?.candidate.id,
      },
      jobOrder: {
        id: jobOrder.id,
      },
      status: 'Target',
    });

    // make call to backend on current domain
    const createTargetPromise = fetch('https://bh-job-match-8ab81b71eadc.herokuapp.com/sendTargetEmail', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        candidate: submission?.candidate,
        jobOrder: jobOrder,
        fromUser: fromUser,
        toUser: submission?.candidate.owner,
        comments: ' ',
      })
    });

    const [createNote, createTarget] = await Promise.all([createNotePromis, createTargetPromise, createSubmissionPromise]);
    console.log(createNote, createTarget, createSubmissionPromise);
  }
}
